import * as React from "react";
import {
  Box,
  Checkbox,
  Typography,
  Link,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useState } from "react";
import PdfViewer from "../../assignment/components/PdfViewer";
import { downloadBlob } from "../../../utils/downloadBlob";

export default function TermsAcceptance({ checked, onChange, termsUrl }) {
  const [open, setOpen] = useState(false);

  const handleOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Checkbox
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          required
        />
        <Typography variant="body2">
          I accept the{" "}
          <Link href="#" onClick={handleOpen} underline="hover">
            Terms and Conditions
          </Link>
        </Typography>
      </Stack>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>Terms and Conditions</DialogTitle>
        <DialogContent dividers>
          <PdfViewer pdfUrl={termsUrl} scrollable />
        </DialogContent>
        <DialogActions>
          <Button
            variant={"outlined"}
            onClick={() => downloadBlob(termsUrl, "FruitifyTerms.pdf")}
          >
            Download
          </Button>
          <Button onClick={handleClose} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
